function Icons() {
    return {
        MuiIcons: {
            defaultProps: {
                // underline: "hover",
            },
        },
        styleOverrides: {
            root: {
                backgroundColor: "white",
                color: "success"
            }
        }
    }
}

export default Icons;
